<nav
    role="navigation"
    id="primaryHeader"
    [ngClass]="(showPerformancePage$ | async) ? 'justify-content-between' : 'justify-content-end'"
    class="navbar navbar-expand-lg navbar-light bg-white border-bottom d-flex align-items-center"
    aria-label="Primary header navigation"
>
    @if (showPerformancePage$ | async) {
        <div id="institutionName" class="ms-4">
            @if (hasMultipleInstitutions()) {
                <div class="d-flex flex-column h-100">
                    <h3 class="mb-3">
                        {{ institutionName() }}
                    </h3>
                    <a
                        href="#"
                        role="button"
                        id="change-institution-link"
                        (click)="$event.preventDefault(); onChangeInstitutionClick()"
                    >
                        Change
                    </a>
                </div>
            } @else {
                <h3 class="mb-0">
                    {{ institutionName() }}
                </h3>
            }
        </div>
    }

    <button
        class="navbar-toggler border-0 me-auto ms-3 px-2 collapsed"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#primaryNav"
        aria-controls="primaryNav"
        aria-expanded="false"
        aria-label="Toggle navigation"
    >
        <span class="navbar-toggler-icon"></span>
    </button>

    <div class="d-flex justify-content-between align-items-center">
        @if (accountInformation$ | async; as accountInformation) {
            <!-- Notifications -->
            <div class="notification-wrapper">
                <button
                    #bellRef
                    type="button"
                    class="me-4 mt-1 bell-wrapper btn btn-link p-0 border-0"
                    (click)="toggleNotifications()"
                    aria-haspopup="true"
                    [attr.aria-expanded]="showNotificationPanel()"
                    aria-controls="notificationPanel"
                    aria-label="Notifications"
                >
                    <i class="fa-regular fa-bell fa-lg text-default"></i>
                    @if (unreadNotificationCount() > 0) {
                        <span class="notification-badge">
                            {{ unreadNotificationCount() }}
                        </span>
                    }
                </button>

                @if (showNotificationPanel()) {
                    <!-- Drop down -->
                    <div
                        id="notificationPanel"
                        class="notification-dropdown"
                        (click)="$event.stopPropagation()"
                        aria-label="Notifications"
                    >
                        <ul>
                            <li>
                                <div class="d-flex justify-content-between align-items-center fw-bold">
                                    <h2 class="ms-3 my-0 py-0">Notifications</h2>
                                    <button class="btn btn-link" (click)="markNotificationsAsRead()"
                                        >Mark as read</button
                                    >
                                </div>
                            </li>
                            <!-- Content -->
                            @if (notifications()?.length > 0) {
                                @for (
                                    notification of notifications().slice(0, viewableNotificationCount);
                                    track notification.Notification.Id
                                ) {
                                    <li>
                                        <notification-template [notification]="notification" [condensedView]="true">
                                        </notification-template>
                                    </li>
                                }
                            } @else {
                                <li>
                                    <p id="emptyStateMessage" class="text-center my-3"
                                        >You have no new notifications.</p
                                    >
                                </li>
                            }
                            <li>
                                <div class="text-center fw-bold">
                                    <a class="btn btn-link" [routerLink]="['/inbox']" (click)="closeNotificationPanel()"
                                        >View Dashboard</a
                                    >
                                </div>
                            </li>
                        </ul>
                    </div>
                }
            </div>

            <div class="me-3 mt-1 dropdown">
                <div class="d-flex">
                    <div class="align-self-center me-2">
                        <div>
                            <p class="mb-0">
                                <strong>{{ accountName$ | async }}</strong>
                            </p>
                        </div>
                    </div>
                    <div
                        class="account-dropdown dropdown text-nowrap d-flex justify-content-center align-items-center rounded-circle border border-2 border-blue-700"
                    >
                        <a
                            role="button"
                            class="dropdown-toggle rounded-circle"
                            href="#"
                            id="accountDropdown"
                            data-bs-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                            aria-label="account dropdown"
                        >
                            <span class="fa-stack">
                                <i class="text-primary-600 fas fa-circle fa-stack-2x"></i>
                                <i class="fal fa-user-md fa-stack-1x fa-inverse"></i>
                            </span>
                        </a>
                        <div class="dropdown-menu custom-dropdown-menu" aria-labelledby="accountDropdown">
                            <a class="dropdown-item" [routerLink]="['manage/settings', accountInformation.ExternalId]">
                                Account Settings
                            </a>
                            <a class="dropdown-item btn btn-link" (click)="onManageTagsClick()">Manage Tags</a>
                            <a
                                class="dropdown-item btn btn-link"
                                [ngClass]="{disabled: !canMimicLearner}"
                                (click)="goToMemberInterface()"
                            >
                                {{ (learnerText$ | async).SingularForm }} Interface
                            </a>
                            <a id="needHelpLink" class="dropdown-item" [href]="needHelpUrl()" target="_blank"
                                >Need Help?</a
                            >
                            <a class="dropdown-item" href="https://truelearn.com/support/" target="_blank"
                                >Send Feedback</a
                            >
                            <a id="blogLink" class="dropdown-item" [href]="blogUrl()" target="_blank">Blog</a>
                            @if (changePortalOptionAvailable) {
                                <a class="dropdown-item" (click)="onChangePortalClick()"> Change Portal </a>
                            }
                            <a class="dropdown-item" (click)="logout()">Log Out</a>
                        </div>
                    </div>
                </div>
            </div>
        }
        <div #collapsibleNav class="collapse primary-nav navbar-collapse" id="primaryNav" aria-labelledby="primaryNav">
            <app-nav-list (navItemClicked)="toggleCollapse()"></app-nav-list>
        </div>
    </div>
</nav>
